var customAttributes = {
  fashion_color: 'swatch'
};
export default (function () {
  var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
      code = _ref.attribute_code;

  return customAttributes[code];
});